<template>
    <div class="home">
        <Header ref="height0" :seachIptGray="true" />
        <div class="paddingBox">
            <div class="bannerImg"  ref="height1">
                <img class="img"
                    src="@/assets/images/banner1.png"
                    alt="" srcset="">
                <div class="bannerTxt __line2">
                    您可以在这里提出「离型工艺」相关问题我们会尽快解答
                </div>
                <div class="goFormPage" @click="goQustionForm">
                    <img src="@/assets/images/questionBtn.png" alt="" srcset="">
                </div>
            </div>
            <!-- <div class="tabBox" ref="height2">
                <scrollTab :tabs="tabsList" @choseTabItemCb="choseTabItemCb"></scrollTab>
            </div> -->
            <van-list v-model="loading" :finished="finished" @load="getChild">
                <div class="listCard">
                    <ul class="listCardBox">
                        <li class="item" v-for="item in list" :key="item.id" @click="goDis(item)">
                            <div class="imgCard">
                                <div class="left">
                                    <p class="t1 __line2">{{ item.title || '' }}</p>
                                    <p class="t2 __line2">{{ item.description }}</p>
                                </div>
                                <div class="right">
                                    <img :src="item.banner" alt="" srcset="">
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </van-list>

            <EmptyState :show="list.length == 0 && !loading" :emptyHeight="emptyHeight" :text="text" />
           
        </div>
        <div style="width:100%;height:64px"></div>
        <tabBar></tabBar>
    </div>
</template>
      
<script>
import { Toast } from "vant";
import Crypt from "@bluedot-tech/vue-ui/es/utils/crypt";
import config from "../config/config";
import Header from "@/components/header";
import scrollTab from "@/components/scrollTab.vue";
import imgCard from "@/components/imgCard.vue";
import tabBar from "@/components/tabBar.vue";
import EmptyState from '@/components/EmptyState.vue';
export default {
    components: {
        Header,
        imgCard,
        scrollTab,
        tabBar,
        EmptyState
    },
    data() {
        return {
            text:"暂无内容",
            tabsList: [],
            tabs: [],
            curType: 0,
            params: {
                type: 1,
                state: "",
                current: 1,
                s_type: "",
            },
            curIndex:0,
            query: null,
            list: [],
            total: 0,
            loading: false,
            finished: false,
            emptyHeight: 0,
            value: "",
            searchValue: "", // 父组件维护的搜索关键词
            imageList: [
                "https://br-education.oss-cn-beijing.aliyuncs.com/learning/20240620/rc-upload-1718862993329-3.jpeg",
                "https://br-education.oss-cn-beijing.aliyuncs.com/learning/20240620/rc-upload-1718862993329-3.jpeg",
                "https://br-education.oss-cn-beijing.aliyuncs.com/learning/20240620/rc-upload-1718862993329-3.jpeg",
                // 添加更多图片路径
            ],
        };
    },
    mounted() {
        this.query = this.$route.query;
        this.initShare();
        // 页面浏览 监测
        this.$dataStatistics({
            page_title: `离型知识`,
        },'访问');
        this.calculateEmptyHeight();
    },

    methods: {
        goQustionForm(){
            this.$dataStatistics('click', '我要提问');
            this.$router.push('/AskQuestion')
        },
        goDis(item){
            this.$dataStatistics('click', '查看离型知识');
            this.$router.push(`/faqDis?id=${item.id}`)
        },
        calculateEmptyHeight() {
            this.$nextTick(() => {
                const headerHeight = this.$refs.height0.$el.offsetHeight;
                const bannerHeight = this.$refs.height1.offsetHeight;
                // const tabBoxHeight = this.$refs.height2.offsetHeight;
                const paddingBox = 200; // Padding value

                // Calculate remaining height
                const remainingHeight =
                    window.innerHeight -
                    headerHeight -
                    // tabBoxHeight -
                    bannerHeight -
                    paddingBox;
                this.emptyHeight = remainingHeight > 0 ? remainingHeight : 0;
            });
        },
        choseTabItemCb({ index,id }) {
            console.log('index,id ---:',index,id);
            
            if (this.curIndex == index) return;
            this.curIndex = index;
            this.childId = id;
            this.reset();
            this.getChild();
        },
        reset() {
            this.list = [];
            this.loading = true;
            this.finished = false;
            this.params.current = 1;
            this.total = 0;
        },
        async getTabList() {
            let params = {
                "filter[type]": 3,
            };
            let res = await this.$http.get("/api/platform/category", { params: params })
            this.tabsList = res.data;
            this.tabsList.unshift({
                id:"",
                name:"全部"
            })
            this.childId = this.tabsList[0].id;

        },

        async getChild() {
            if (this.tabsList.length <= 0) {
                await this.getTabList();
            }
            if (this.list?.length < this.total) {
                this.params.current++;
            }
            let params = {
                "filter[type]": this.childId,
                'filter[status]': 1,
                'filter[s_type]': 3,
                'current': this.params.current,
            };
            this.loading = true;
            this.$http.get("/api/platform/cases", { params: params }).then((res) => {
                this.params.current = res?.data?.current;
                this.total = res?.data?.total;
                this.list = this.list.concat(res.data.data);
                this.$nextTick(() => {
                    this.loading = false;
                    if (this.list?.length >= this.total) {
                        this.finished = true;
                    }
                });
            });
        },
    },
};
</script>
<style lang="less" scoped>
.empty {
    width: 100%;

    .emptyImg {
        width: 120px;
    height: 144px;
        display: block;
    }
}

.home {
    position: relative;
    width: 100%;
    background: #FAFAFA;
    min-height: 100vh;
    .bannerContent {
        width: 100%;
        height: 394px;
        margin: 0 auto;
    }

    .tabBox {
        z-index: 2;
        position: sticky;
        top: 0;
        background: #FAFAFA;
    }

    .titleBox {
        font-size: 34px;
        color: #991d85;
        font-weight: bold;
        margin-top: 31px;

        .title {
            margin-left: 16px;
        }

        .line {
            width: 6px;
            height: 32px;
            background: #991d85;
            border-radius: 3px;
        }
    }

    .paddingBox {
        z-index: 1;
        position: relative;
        padding: 0 12px;
    }

    .searchBox {
        position: relative;
        margin-top: 27px;
    }

    .listCard {
        margin-top: 12px;
    }

    .bg {
        width: 200px;
        height: 200px;

        background-size: 100% 100%;
    }
}

.prodCard {
    padding: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: linear-gradient(270deg, #FFFFFF 0%, #FFFFFF 100%);
    border-radius: 8px 8px 8px 8px;
    border: 1px solid;
    border-image: linear-gradient(270deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0)) 1 1;
    margin-bottom: 8px;

    .left {
        .t1 {
            font-size: 16px;
            color: #333333;
            line-height: 24px;
        }

        .t2 {
            font-size: 14px;
            color: #9F9F9F;
            line-height: 20px;
            margin-top: 8px;
        }
    }

    .right {
        width: 20px;
        height: 20px;
        flex-shrink: 0;

        img {
            width: 100%;
            height: 100%;
        }
    }
}

.imgCard {
    word-break: break-all;
    padding:12px 16px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    background: linear-gradient(270deg, #FFFFFF 0%, #FFFFFF 100%);
    border-radius: 8px 8px 8px 8px;
    border: 1px solid;
    border-image: linear-gradient(270deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0)) 1 1;
    margin-bottom: 12px;

    .left {
        .t1 {
            font-size: 16px;
            color: #333333;
            line-height: 24px;
        }

        .t2 {
            font-size: 14px;
            color: #9F9F9F;
            line-height: 20px;
            margin-top: 4px;
        }
    }

    .right {
        width: 121px;
        height: 80px;
        border-radius: 4px 4px 4px 4px;
        flex-shrink: 0;
        margin-left: 16px;

        img {
            width: 100%;
            height: 100%;
            border-radius: 4px 4px 4px 4px;
        }
    }
}

.bannerImg {
    width: 351px;
    height: 110px;
    border-radius: 8px;
    margin-top: 18px;
    margin-bottom: 12px;
    position: relative;


    .img {
        width: 100%;
        height: 100%;
        border-radius: 8px;

    }

    .bannerTxt {
        position: absolute;
        top: 12px;
        left: 16px;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 28px;
        width: 300px;
    }
}

.goFormPage {
    position: absolute;
    right: 12px;
    bottom: 12px;
    width: 80px;
    height: 28px;
    img{
        width: 100%;
        height: 100%;
    }
}
</style>
      